import { store } from 'store';
import type { ChatUserModel } from 'types/chat-users/chat-user';

/** חיפוש משתמש שיחה לפי מספר טלפון בכל רשימות התצוגות הטעונות */
export function findChatUserByPhoneInStore(phone: string): ChatUserModel | undefined {
  const s = store.getState().chat;
  const arrs = [
    s.chatUsers.myChatUsers,
    s.chatUsers.mySnoozedChatUsers,
    s.chatUsers.notMyChatUsers,
    s.chatUsers.unassignedChatUsers,
    s.chatUsers.botsChatUsers,
    s.chatUsers.allChatUsers,
    s.chatUsers.customChatUsers,
    s.chatUsers.completedChatUsers,
  ];
  for (const arr of arrs) {
    const u = arr.find((c) => c.UserDisplayPhoneNumber === phone);
    if (u) return u;
  }
  return undefined;
}
